import moment from 'moment/moment';
import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import InitApplication from './init-application';
import MaintenanceComponent from './pages/maintainane/maintainance.component';
import { useGlobalErrorLogger } from './error-handler';

const runtimeConfigPath = `${process.env.PUBLIC_URL || ''}/app-config.json`;

const App = () => {
  const [isConfigLoaded, setIsConfigLoaded] = useState(false);
  const [maintenanceWindow, setMaintenanceWindow] = useState({
    startTime: '',
    endTime: '',
  });
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const { startTime, endTime } = maintenanceWindow;

  useEffect(() => {
    const loadRuntimeConfig = async () => {
      try {
        const response = await fetch(`${runtimeConfigPath}?t=${Date.now()}`, {
          cache: 'no-store',
        });

        if (!response.ok) {
          setIsConfigLoaded(true);
          return;
        }

        const runtimeConfig = await response.json();
        const maintenanceConfig = runtimeConfig.Maintainance || runtimeConfig.Maintenance || {};

        setMaintenanceWindow({
          startTime: maintenanceConfig.StartTime || '',
          endTime: maintenanceConfig.EndTime || '',
        });
      } catch {
        setMaintenanceWindow({
          startTime: '',
          endTime: '',
        });
      } finally {
        setIsConfigLoaded(true);
      }
    };

    loadRuntimeConfig();
  }, []);

  useEffect(() => {
    if (startTime && endTime) {
      const startUTC = moment.tz(startTime, 'DD/MM/YYYY hh:mm A', 'Asia/Kolkata').utc();
      const endUTC = moment.tz(endTime, 'DD/MM/YYYY hh:mm A', 'Asia/Kolkata').utc();

      const nowUTC = moment.utc();

      setIsUnderMaintenance(nowUTC.isBetween(startUTC, endUTC, null, '[]'));
    } else {
      setIsUnderMaintenance(false);
    }
  }, [startTime, endTime]);

  useGlobalErrorLogger();

  return (
    <HelmetProvider>
      {isConfigLoaded && (isUnderMaintenance ? <MaintenanceComponent toDate={endTime} /> : <InitApplication />)}
    </HelmetProvider>
  );
};
export default App;
